import { FeatureLaunch, isFeatureLaunched } from '@commenda/feature-launches';
import { IEntitlement } from '@commenda/types';
import { SWRFetcher } from '@commenda/utils';
import { Currency } from '@prisma/client';
import useSWR from 'swr';

export enum BillingIntervalEnum {
  MONTH = 'MONTH',
  QUARTER = 'QUARTER',
  YEAR = 'YEAR',
}

export type TSubscriptionPlanItem = {
  id: string;
  name: string;
  price: number;
  quantity: number;
  status: string;
  type: string;
  entitlements: (IEntitlement & { entityName: string })[];
};

export type TSubscriptionResponse = {
  id: string;
  status: string;
  nextBillingDate?: number;
  billingFrequency: BillingIntervalEnum;
  currency: Currency;
  nextBillingAmount?: number;
  plans: TSubscriptionPlanItem[];
};

export type TSubscriptionsApiResponse = {
  data: TSubscriptionResponse[];
  count: number;
};

export function useListSubscriptions({ companyId }: { companyId: number }) {
  // Read cutover: when launched, read subscriptions from Commenda's mirror tables instead of Chargebee.
  const requestURL = isFeatureLaunched(FeatureLaunch.BILLING_READ_FROM_MIRROR, companyId)
    ? `commenda-billing/mirror/subscriptions?companyId=${companyId}`
    : `billing-new/purchased-services/subscriptions?companyId=${companyId}`;

  return useSWR<TSubscriptionsApiResponse>(
    requestURL,
    SWRFetcher({
      method: 'GET',
    })
  );
}
